var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config && _vm.iconStr)?_c('div',{staticClass:"tree-icon"},[(_vm.iconStr.indexOf('el-') === 0)?_c('i',{class:_vm.iconStr}):(_vm.iconStr.indexOf('http') === 0)?_c('img',{attrs:{"src":_vm.iconStr,"alt":""}}):_c('i',{class:['iconfont', _vm.iconStr]})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }